import { render, staticRenderFns } from "./AffiliateLogin.vue?vue&type=template&id=02902654&scoped=true&"
import script from "./AffiliateLogin.vue?vue&type=script&lang=ts&"
export * from "./AffiliateLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateLogin.vue?vue&type=style&index=0&id=02902654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02902654",
  null
  
)

export default component.exports